/**
 * @namespace BX.UI.Uploader
 */
export const FileOrigin = {
	CLIENT: 'client',
	SERVER: 'server',
};
